<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="subtitle-1 font-weight-bold">Parâmetros da projeção</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Nome da Turma"
                  :value="input.nomeTurma"
                  @input="update('nomeTurma', $event)"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Quantidade de alunos"
                  :value="input.quantidadeAlunos"
                  @input="updateNumber('quantidadeAlunos', $event, true)"
                  type="number" min="1"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <decimal-number
                  label="Mensalidade por aluno"
                  :value="input.mensalidade"
                  @input="update('mensalidade', $event)"
                  outlined dense
                ></decimal-number>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  label="Data de início (yyyy-MM-dd)"
                  :value="input.dataInicio"
                  @input="update('dataInicio', $event)"
                  type="date"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Taxa Heppi %"
                  :value="input.taxaHeppi"
                  @input="updateNumber('taxaHeppi', $event)"
                  type="number" step="0.1" min="0"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Rendimento mensal %"
                  :value="input.taxaRendimentoMensal"
                  @input="updateNumber('taxaRendimentoMensal', $event)"
                  type="number" step="0.1" min="0"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Alíquota IR %"
                  :value="input.aliquotaIR"
                  @input="updateNumber('aliquotaIR', $event)"
                  type="number" step="0.1" min="0"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Horizonte em meses"
                  :value="input.horizonteMeses"
                  @input="updateNumber('horizonteMeses', $event, true)"
                  type="number" min="1"
                  outlined dense hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col v-for="card in kpiCards" :key="card.label" cols="12" sm="6" md="auto" class="flex-md-grow-1">
        <v-card outlined class="text-center pa-2 fill-height">
          <div class="caption text--secondary text-uppercase">{{ card.label }}</div>
          <div class="text-h6 font-weight-bold" :class="card.color">{{ card.value }}</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'TabProjecaoHeppi',
  components: { DecimalNumber },
  props: {
    input: { type: Object, required: true },
    kpis: { type: Object, default: () => ({}) }
  },
  computed: {
    kpiCards () {
      return [
        { label: 'Receita Total', value: this.$options.filters.price(this.kpis.receitaTotal || 0), color: 'primary--text' },
        { label: 'Lucro Projetado', value: this.$options.filters.price(this.kpis.lucroProjetado || 0), color: 'success--text' },
        { label: 'ROI', value: ((this.kpis.roi || 0).toString().replace('.', ',')) + ' %', color: 'success--text' },
        { label: 'Saldo Final', value: this.$options.filters.price(this.kpis.saldoFinal || 0), color: 'primary--text' },
        { label: 'Rendimento Bruto', value: this.$options.filters.price(this.kpis.rendimentoBrutoTotal || 0), color: 'primary--text' }
      ]
    }
  },
  methods: {
    update (key, value) {
      this.$emit('update', { ...this.input, [key]: value })
    },
    updateNumber (key, value, integer) {
      let parsed = integer ? parseInt(value, 10) : parseFloat(value)
      if (isNaN(parsed)) parsed = 0
      this.update(key, parsed)
    }
  }
}
</script>
